import axios from 'axios';

const tmdbApiKey = process.env.REACT_APP_TMDB_KEY;

export const moviesApi = axios.create({
  baseURL: 'https://api.themoviedb.org/3/',
  params: {
    api_key: tmdbApiKey,
  },
});

export const fetchRequestToken = async () => {
  try {
    const { data } = await moviesApi.get(`authentication/token/new?api_key=${tmdbApiKey}`);
    const token = data.request_token;

    if (data.success) {
      localStorage.setItem('request_token', token);
      window.location.href = `https://www.themoviedb.org/authenticate/${token}?redirect_to=${window.location.origin}`;
    }
  } catch (error) {
    console.log('Sorry, your token could not be created.', error);
  }
};

export const createSessionId = async () => {
  const token = localStorage.getItem('request_token');

  if (token) {
    try {
      const { data: { session_id } } = await moviesApi.post(`authentication/session/new?api_key=${tmdbApiKey}`, {
        request_token: token,
      });
      localStorage.setItem('session_id', session_id);
      return session_id;
    } catch (error) {
      console.log('Unable to create a session.', error);
    }
  }
};
